import React from 'react'
import ReactDOM from 'react-dom'
import { ApolloProvider } from '@apollo/client'
import { Provider } from 'react-redux'

import { isUserAuthenticated } from './lib/providers/user'
import { fetchUser } from './store/actions/user'
import apolloClient from './graphql'

import store from './store'
import './index.scss'
import App from './App'
// import wsConnect from './ws';

function installChunkLoadRecovery() {
	const isChunkFailure = (msg) =>
		typeof msg === 'string' &&
		(msg.includes('Loading chunk') || msg.includes('ChunkLoadError'))

	window.addEventListener('error', (e) => {
		if (isChunkFailure(e.message)) {
			if (!sessionStorage.getItem('chunk_reload_once')) {
				sessionStorage.setItem('chunk_reload_once', '1')
				window.location.reload()
			}
		}
	})
	window.addEventListener('unhandledrejection', (e) => {
		const msg = e.reason && (e.reason.message || String(e.reason))
		if (isChunkFailure(msg)) {
			if (!sessionStorage.getItem('chunk_reload_once')) {
				sessionStorage.setItem('chunk_reload_once', '1')
				window.location.reload()
			}
		}
	})
}

installChunkLoadRecovery()

async function resolvePreRenderRequirements() {
	if (isUserAuthenticated()) {
		await store.dispatch(fetchUser())
	}
}

resolvePreRenderRequirements().then(() => {
	ReactDOM.render(
		<React.StrictMode>
			<Provider store={store}>
				<ApolloProvider client={apolloClient}>
					<App />
				</ApolloProvider>
			</Provider>
		</React.StrictMode>,
		document.getElementById('root')
	)
})
